var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chartist',{attrs:{"ratio":"ct-chart","data":_vm.data,"options":_vm.options,"type":"Line"}})}
var staticRenderFns = []

export { render, staticRenderFns }